import React from 'react'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { useViewStore } from '../../Contexts/ViewContext'
import { useUtilsStore } from '../../Contexts/UtilsContext'
import { CurrentSubView } from '../../../models/enums'
import ParameterButton from './ParameterButton'

const LanguageButton = (): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)
  const supported = useLocaleStore((state) => state.supported)
  const themeColors = useViewStore((state) => state.themeColors)
  const currentSubView = useUtilsStore((state) => state.currentSubView)
  const setCurrentSubView = useUtilsStore(
    (state) => state.actions.setCurrentSubView
  )

  /**
   * On call :
   *  - change RetorikContext's currentSubView state
   */
  const handleClick = (): void => {
    setCurrentSubView(
      currentSubView === CurrentSubView.languages
        ? CurrentSubView.none
        : CurrentSubView.languages
    )
  }

  return supported.length > 1 ? (
    <ParameterButton
      title={translation.common.lang}
      icon='lang'
      color={
        currentSubView === CurrentSubView.languages
          ? themeColors.secondary
          : '#A4A7AF'
      }
      onClick={handleClick}
    />
  ) : (
    <React.Fragment />
  )
}

export default LanguageButton
